/* eslint-disable */
export default {
  currentCall: 'Current Call',
  viewCalls: 'View calls',
  view: 'View',
  incomingCall: '{numberOf} incoming call',
  incomingCalls: '{numberOf} incoming calls',
  callOnHold: '{numberOf} call on hold',
  callsOnHold: '{numberOf} calls on hold',
  otherDeviceCall: '{numberOf} Call on other devices',
  otherDeviceCalls: '{numberOf} Calls on other devices',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
